"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const building_blocks_ui_common_1 = require("@acko-tech/building-blocks.ui.common");
const images_1 = require("./images");
const CloseButtonWrapper = building_blocks_ui_common_1.styled.div `
  position: absolute;
  right: 0;
  ${(props) => (props.setTopHeight ? `top: 0px` : '')};
  ${(props) => props.styles}
  max-width: 16px;
  max-height: 16px;
  cursor: pointer;
`;
const Wrapper = building_blocks_ui_common_1.styled.div `
  display: flex;
  width: 100%;
  position: relative;
  ${(props) => props.align === 'center' && 'justify-content: center'};
  align-items: center;
`;
function ModalHeader(props) {
    const { header, closeButton, onClick, align, hideTopPadding, closeButtonStyles, headerStyles, } = props;
    return (react_1.default.createElement(Wrapper, { align: align, style: Object.assign({}, headerStyles) },
        header,
        closeButton && (react_1.default.createElement(CloseButtonWrapper, { type: "button", onClick: onClick, setTopHeight: hideTopPadding, styles: closeButtonStyles },
            react_1.default.createElement(images_1.Cross, null)))));
}
ModalHeader.defaultProps = {
    closeButton: false,
    onClick: () => null,
    header: react_1.default.createElement("div", null),
    align: '',
};
exports.default = (0, react_1.memo)(ModalHeader);
//# sourceMappingURL=header.js.map